let language = {
    "STORES-DELETE-ALERT-INFO-TITLE": "删除项目",
    "STORES-DELETE-ALERT-INFO-CONTENT": "未选择任何项目",
    "STORES-DELETE-ALERT-WARNING-TITLE": "删除店铺",
    "STORES-DELETE-ALERT-WARNING-CONTENT": "确定要删除店铺吗？",
    "STORES-DELETE-ALERT-INFO-TITLE-RESULT": "删除结果",
    "STORES-DELETE-ALERT-INFO-CONTENT-RESULT": "删除失败：",
    "STORES-DELETE-ALERT-INFO-CONTENT-RESULT-SUCCESS": "删除成功",
    "STORES-REFRESH-SUCCESS": "刷新成功！",
    "STORES-REFRESH-FAIL": "刷新失败！",
    "STORES-STATUS-ACTIVATE-TITLE": "激活店铺",
    "STORES-STATUS-ACTIVATE-CONTENT": "确定要激活店铺吗？",
    "STORES-ALERT-SUCCESS-TITLE": "成功",
    "STORES-ALERT-ACTIVATE-SUCCESS-CONTENT": "激活成功！",
    "STORES-ALERT-ENABLE-SUCCESS-CONTENT": "启用成功！",
    "STORES-ALERT-FAIL-TITLE": "失败",
    "STORES-ALERT-ACTIVATE-FAIL-CONTENT": "启用失败！",
    "STORES-ALERT-SAVE-FAIL-CONTENT": "保存失败！",
    "STORES-ALERT-REMOVE-FAIL-CONTENT": "删除失败！",
    "STORES-ALERT-AUTHORIZATION-FAIL-CONTENT": "获取外部授权失败！",
    "STORES-ALERT-URL-EXISTS-FAIL-CONTENT": "该URL已存在！",
    "STORES-ALERT-INCORRECT-CONNECTION-FAIL-CONTENT": "连接信息不正确！",
    "STORES-ALERT-CONNECT-FAIL-CONTENT": "连接失败！",
    "STORES-STATUS-CLOSE-TITLE": "确定要使店铺失效吗？",
    "STORES-STATUS-CLOSE-CONTENT": "当停用商店时，您的产品和订单将失去与您的在线电子商店的连接。您要继续使该商店处于非活动状态吗?",
    "STORES-STATUS-CLOSE-BTN": "停用店铺",
    "STORES-STATUS-CLOSE-SUCCESS-CONTENT": "停用成功！",
    "STORES-STATUS-CLOSE-FAIL-CONTENT": "停用失败！",
    "STORES-STATUS-DRAFT-QUESTION-TITLE": "草稿店铺",
    "STORES-STATUS-DRAFT-QUESTION-CONTENT": "确定要将店铺设置为草稿吗？",
    "STORES-STATUS-DRAFT-FAIL-CONTENT": "设置草稿失败！",
    "STORES-STATUS-DRAFT-SUCCESS-CONTENT": "设置草稿成功！",
    "STORES-ALERT-BILLING-ADDRESS-CONTENT": "账单地址缺少邮政编码，请填写。",
    "STORES-ALERT-REFUND-ADDRESS-CONTENT": "退款地址缺少邮政编码，请填写。",
    "STORES-ALERT-REMOVE-STORE-TITLE": "删除店铺",
    "STORES-ALERT-REMOVE-STORE-CONTENT": "此操作将删除所有与店铺相关的内容！",
    "STORES-ALERT-ENABLE-STORE-TITLE": "启用店铺",
    "STORES-ALERT-ENABLE-STORE-CONTENT": "确定要启用店铺吗？",
    "STORES-CREATE-STORE-ISSUE-TITLE":"创建店铺异常",
    "STORES-CREATE-STORE-ISSUE-CONTENT":"创建手动订单店铺时出现问题，请重试，如果问题仍然存在，请联系我们{{supportmail}}",
};

export { language }
